import { render, staticRenderFns } from "./single-dimension-mind-res.vue?vue&type=template&id=145463e7&scoped=true"
import script from "./single-dimension-mind-res.vue?vue&type=script&lang=ts"
export * from "./single-dimension-mind-res.vue?vue&type=script&lang=ts"
import style0 from "./single-dimension-mind-res.vue?vue&type=style&index=0&id=145463e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145463e7",
  null
  
)

export default component.exports